<script setup>
defineProps({
  keepAlive: { type: Boolean, default: true },
});
</script>

<template>
  <div
    class="flex h-full flex-1 flex-col justify-between overflow-auto bg-gradient-to-br from-n-surface-1 via-n-surface-1 to-n-blue-2/20 px-6"
  >
    <router-view v-slot="{ Component }">
      <keep-alive v-if="keepAlive">
        <component :is="Component" />
      </keep-alive>
      <component :is="Component" v-else />
    </router-view>
  </div>
</template>
